<!-- 确认时间 -->
<template>
  <div>
    <zlr-progress :percent="percent"></zlr-progress>
    <div class="mentor-zoom-confirm">
      <div>
        <div>
          <h1>请重新确认时间</h1>
          <div class="mentor-zoom-confirm-con">
            <div class="mentor-zoom-confirm-item">
              <p>1. 请选择时区</p>
              <div class="active">
                <Select placeholder="Select"
                        v-model="formData.menteeZone"
                        @on-change="zoneChange">
                  <Option :value="item.value"
                          v-for="(item,index) in zoneMap"
                          :key="index">{{item.title}}</Option>
                </Select>
              </div>
            </div>
            <div class="mentor-zoom-confirm-item"
                 :class="{'zlr-cover': !formData.menteeZone}">
              <p>2. 导师重新给出的预约时间</p>
              <div class="mentor-zoom-confirm-select">
                <div v-for="(item, index) in zoneList"
                     :key="index"
                     :class="{'active-bg': expectRange[0] === item.minTimeStr && expectRange[1] === item.maxTimeStr}"
                     @click="expectTimeHandle(item)">{{`${item.minTimeStr} - ${item.maxTimeStr}`}}</div>
              </div>
            </div>
            <div class="mentor-zoom-confirm-item"
                 :class="{'zlr-cover': !(expectRange[0] && expectRange[1])}">
              <p>3. 请选择预约开始时间</p>
              <div class="active">
                <!-- <DatePicker type="datetime"
                            placeholder="Select time"
                            style="width: 100%"
                            v-model="formData.resultTimeStr"
                            format="yyyy-MM-dd HH:mm"></DatePicker> -->
                <div style="display:flex;  justify-content: space-between;">
                  <DatePicker placeholder="Select date and time"
                              type="date"
                              v-model="formData.resultTimeStrStart"
                              style="width:360px;"></DatePicker>
                  <TimePicker type="time"
                              placeholder="Select time"
                              format="HH:mm"
                              :steps="[1, 5]"
                              v-model="formData.resultTimeStrEnd"
                              style="width:360px;"></TimePicker>
                </div>

              </div>
              <div v-if="errorMsg"
                   class="error-msg">
                {{errorMsg}}
              </div>
              <div class="mentor-zoom-confirm-btn">
                <Button class="btn"
                        @click="confirmHandle"
                        :loading="isSub">确认时间</Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// api
import { subAppConfirm, getAppTimeZone } from '@/api/appointment'
// components
import ZlrProgress from '_c/progress/progress'
// constant
import { zoneMap } from '@/constant'
import dayjs from 'dayjs'
export default {
  name: '',
  components: {
    ZlrProgress
  },
  data () {
    return {
      zoneMap,
      formData: {
      },
      appointmentId: this.$route.query.id,
      percent: 0,
      isSub: false,
      zoneList: [{
        minTimeStr: '',
        maxTimeStr: ''
      }, {
        minTimeStr: '',
        maxTimeStr: ''
      },
      {
        minTimeStr: '',
        maxTimeStr: ''
      }],
      expectRange: [],
      errorMsg: ''
    }
  },
  computed: {},
  mounted () {
  },
  methods: {
    // 确认时间
    confirmHandle () {
      this.errorMsg = ''
      let data = JSON.parse(JSON.stringify(this.formData))
      if (!data.resultTimeStrStart || !data.resultTimeStrEnd) {
        this.errorMsg = '请选择时间'
        return false
      }
      // if (!data.resultTimeStr) {
      //   this.errorMsg = '请选择时间'
      //   return false
      // }
      data.resultTimeStr = dayjs(data.resultTimeStrStart).format('YYYY-MM-DD') + ' ' + data.resultTimeStrEnd
      let time = dayjs(data.resultTimeStr).valueOf()
      let minTime = dayjs(this.expectRange[0]).valueOf()
      let maxTime = dayjs(this.expectRange[1]).valueOf()
      if (time < minTime || time > maxTime) {
        this.errorMsg = '不是选择的范围内'
        return false
      }
      data.resultTimeStr = dayjs(data.resultTimeStr).format('YYYY-MM-DD HH:mm')
      data.appointmentTimeId = this.appointmentId
      this.isSub = true
      subAppConfirm(data).then(res => {
        this.$zlr_message('提交成功', 'success')
        this.linkPage()
      }).catch(error => {
        this.$zlr_message(error.message, 'error')
      }).then(() => {
        this.isSub = false
      })
    },
    // 跳转页面
    linkPage () {
      let routerName = this.$route.name
      let name = ''
      if (routerName === 'project-interview-zoom') {
        name = 'project-interview'
      }
      if (routerName === 'mentor-zoom') {
        name = 'mentor-application-record'
      }
      this.$router.push({
        name
      })
    },
    // 切换时区
    zoneChange () {
      let zone = this.formData.menteeZone
      this.$set(this.formData, 'expectRange', '')
      this.$set(this.formData, 'resultTimeStrStart', '')
      this.$set(this.formData, 'resultTimeStrEnd', '')
      this.$set(this.formData, 'resultTimeStr', '')
      this.expectRange = []
      this.errorMsg = ''
      getAppTimeZone({
        zone,
        appointmentId: this.appointmentId
      }).then(res => {
        this.zoneList = res.data.list
      })
    },
    // 期望时间
    expectTimeHandle (item) {
      this.$set(this.expectRange, 0, item.minTimeStr)
      this.$set(this.expectRange, 1, item.maxTimeStr)
      this.$set(this.formData, 'expectRange', item.minTimeStr)
    }
  },
  watch: {
    formData: {
      handler (data) {
        let index = 0
        this.errorMsg = ''
        if (data.menteeZone) index++
        if (data.expectRange) index++
        if (data.resultTimeStrStart && data.resultTimeStrEnd) index++
        this.percent = (index / 3).toFixed(2) * 100
      },
      deep: true
    }
  }
}
</script>
<style lang='less' scoped>
</style>
